import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PopularPlaceListRequestBody, PopularPlaceListResponse } from "./types";

export class PopularPlaceListAPI extends BaseAPI<
    PopularPlaceListRequestBody,
    PopularPlaceListResponse
> {
    protected route = ApiRoutes.popular_place.list;
    protected method = RequestMethod.GET;
}
